import { render, staticRenderFns } from "./noticeBar.vue?vue&type=template&id=200d925b&scoped=true&"
import script from "./noticeBar.vue?vue&type=script&lang=ts&"
export * from "./noticeBar.vue?vue&type=script&lang=ts&"
import style0 from "./noticeBar.vue?vue&type=style&index=0&id=200d925b&lang=less&scoped=true&"
import style1 from "./noticeBar.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d925b",
  null
  
)

export default component.exports